export enum IupicsMenuType {
  INFO_WINDOW = 'Info Window',
  WINDOW = 'Window',
  SUMMARY = 'Summary',
  REPORT = 'Report',
  PROCESS = 'Process',
  WORKFLOW = 'Workflow',
  FORM = 'Form',
  TASK = 'Task',
}

export type MenuCategoryUI = {
  /**
   * `-1` = Tous les menus\
   * `0` = Les plus pertinent\
   * `0 < id > Infinity` = Les catégories\
   * `Infinity` = (Sans catégorie)
   */
  id: number;
  name: string;
  isSelected?: boolean;
  icon: string;
  /** names of the folders above the category in the menu tree (top first) */
  path?: string[];
};

export type MenuFavoritesCategoryUI = {
  id?: number;
  name: string;
  seqNo?: number;
};

export class MenuItemUI {
  menuId: number;
  angularClass?: string;
  description?: string;
  menuCategory?: MenuCategoryUI;
  menuType: IupicsMenuType;
  actionID: number;
  iconClass: string;
  color: string;
  name: string;
  tags: string[];
  isSummary: boolean;
  parentId: number;
  id?: string;
  seqNo?: number;
  width?: number;
  /** names of the folders above the menu in the menu tree (top first, its category last) */
  path?: string[];
}
